<template>
  <div class="cashcreation">
    <div class="header-text" :style="{ width: ElementHeight }">
      <h1 class="header-title">
        GIADA Friends券库管理-修改{{
          CouponsState == 1
            ? "(未启用状态)"
            : CouponsState == 0
            ? "(已启用)"
            : CouponsState == 2
            ? "(已禁用)"
            : ""
        }}
      </h1>
      <div class="buttom-div">
        <el-button class="push-button" @click="preservation"
          >保存</el-button
        >
        <el-button
          class="push-button"
          icon="iconfont icon-fanhui"
          @click="backHistory"
          >返回</el-button
        >
      </div>
    </div>
    <div class="header-text1"></div>
    <div class="biaoti">
      <span>基本信息</span>
    </div>
    <div>
      <el-card>
        <!-- 表单 -->
        <div>
          <el-form
            :rules="BasicDataRules"
            :label-position="labelPosition"
            label-width="155px"
            size="small"
            class="form-div"
            ref="BasicInformation"
            :model="BasicData"
          >
            <el-row :gutter="100">
              <el-col :span="18">
                <el-form-item label="卷库编号">
                  <el-input
                    disabled
                    v-model="CouponsSelectChang.coupGrpNo"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="券库名称" prop="couponsName">
                  <el-input
                    :disabled="CouponsState == 1 ? false : true"
                    v-model="BasicData.couponsName"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="券库后台名称" prop="innerCoupName">
                  <el-input
                    :disabled="CouponsState == 1 ? false : true"
                    v-model="BasicData.innerCoupName"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="礼券金额" prop="coupValue">
                  <el-input
                    :disabled="CouponsState == 1 ? false : true"
                    type="Number"
                    v-model="BasicData.coupValue"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item
                  label="使用的业务系统"
                  prop="systemBusinessSelect"
                >
                  <el-checkbox-group
                    :disabled="CouponsState == 1 ? false : true"
                    v-model="BasicData.systemBusinessSelect"
                  >
                    <el-checkbox
                      :label="item.appName"
                      v-model="item.IsCheck"
                      :checked="item.IsCheck"
                      v-for="(item, index) in BasicData.systemBusiness"
                      :key="index"
                    ></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="券可用门店" prop="isAllStore">
                  <el-radio-group
                    :disabled="CouponsState == 1 ? false : true"
                    v-model="BasicData.isAllStore"
                  >
                    <el-radio label="全部门店"></el-radio>
                    <el-radio label="部分门店"></el-radio>
                    <el-button
                      size="mini"
                      :disabled="
                        CouponsState != 1 || BasicData.isAllStore != '部分门店'
                      "
                      @click="outletVisible = true"
                      >选择门店</el-button
                    >
                  </el-radio-group>
                  <el-form-item :prop="isStoreSelectionMethod">
                    <textarea
                      name=""
                      id=""
                      rows="8"
                      readonly
                      class="textareaClass textareaClass-store"
                      v-model="BasicData.listOfSomeStoreslStr"
                    ></textarea>
                  </el-form-item>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="使用需知" prop="usageNotice">
                  <el-input
                    type="textarea"
                    :disabled="CouponsState == 1 ? false : true"
                    class="textareaClass"
                    :autosize="{ minRows: 4, maxRows: 8 }"
                    v-model="BasicData.usageNotice"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item
                  label="是否进行商品折扣限制"
                  prop="isLimitGoodsDiscount"
                >
                  <el-checkbox-group
                    @change="changeisLimitGoodsDiscount"
                    :disabled="CouponsState == 1 ? false : true"
                    v-model="BasicData.isLimitGoodsDiscount"
                  >
                    <el-checkbox
                      :checked="BasicData.isLimitGoodsDiscount"
                      v-model="BasicData.isLimitGoodsDiscount"
                    ></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item
                  label="最高折扣"
                  prop="maxDiscount"
                  :rules="
                    BasicData.isLimitGoodsDiscount
                      ? [
                          {
                            required: true,
                            message: '请输入最高折扣',
                            trigger: 'blur',
                          },
                        ]
                      : [{ required: false }]
                  "
                >
                  <el-input
                    :disabled="
                      CouponsState != 1 || !BasicData.isLimitGoodsDiscount
                    "
                    type="Number"
                    v-model="BasicData.maxDiscount"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="礼品不可转赠">
                  <el-checkbox-group
                    :disabled="CouponsState == 1 ? false : true"
                    v-model="BasicData.ifGiving"
                  >
                    <el-checkbox
                      :checked="BasicData.ifGiving"
                      v-model="BasicData.ifGiving"
                    ></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="最多使用张数" prop="useMaxQty">
                  <el-input
                    :disabled="CouponsState == 1 ? false : true"
                    type="Number"
                    v-model="BasicData.useMaxQty"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="使用最低金额限制" prop="amountLimit">
                  <el-input
                    :disabled="CouponsState == 1 ? false : true"
                    type="Number"
                    v-model="BasicData.amountLimit"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24">
                <el-form-item
                  label="券有效期"
                  prop="SecuritiesExpirationTypeSelect"
                >
                  <el-radio-group
                    :disabled="CouponsState == 1 ? false : true"
                    v-model="BasicData.SecuritiesExpirationTypeSelect"
                    class="periodOfValidity"
                  >
                    <el-form-item prop="123">
                      <el-radio :label="SecuritiesExpirationType[0].id"
                        >永不过期</el-radio
                      >
                    </el-form-item>
                    <el-form-item prop="validDaySdata">
                      <el-radio :label="SecuritiesExpirationType[1].id">
                        <span style="font-size: 14px"
                          >有效期天数，从领券日期起</span
                        >
                        <el-input
                          :disabled="
                            CouponsState != 1 ||
                            BasicData.SecuritiesExpirationTypeSelect != 2
                          "
                          style="width: 90px"
                          v-model="BasicData.validDaySdata"
                        ></el-input>
                        <span style="font-size: 14px">天内有效</span>
                      </el-radio>
                    </el-form-item>
                    <el-form-item prop="datePicker">
                      <el-radio :label="SecuritiesExpirationType[2].id">
                        <span style="font-size: 14px">有效期范围从</span>
                        <el-date-picker
                          :disabled="
                            CouponsState != 1 ||
                            BasicData.SecuritiesExpirationTypeSelect != 3
                          "
                          v-model="BasicData.datePicker"
                          type="daterange"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          :picker-options="pickerOptions"
                        >
                        </el-date-picker>
                      </el-radio>
                    </el-form-item>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24">
                <el-form-item label="券发送提醒">
                  <el-radio-group v-model="BasicData.pubCoupProvideMode">
                    <el-radio
                      v-for="(item, index) in CouponreminderMethod"
                      :key="index"
                      :label="item.id"
                      >{{ item.detailText }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24">
                <el-form-item label="券核销提醒">
                  <el-radio-group v-model="BasicData.pubVeriCoupMode">
                    <el-radio
                      v-for="(item, index) in CouponreminderMethod"
                      :key="index"
                      :label="item.id"
                      >{{ item.detailText }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24" class="MaturityOfSecurities">
                <el-form-item label="券到期提醒">
                  <el-radio-group v-model="BasicData.expirationMode">
                    <el-radio
                      v-for="(item, index) in CouponreminderMethod"
                      :key="index"
                      :label="item.id"
                      >{{ item.detailText }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item prop="expirationTime" style="margin-left: -50px">
                  <span style="font-size: 14px">券到期前</span>
                  <el-input
                    style="width: 90px"
                    type="Number"
                    v-model="BasicData.expirationTime"
                  ></el-input>
                  <span style="font-size: 14px">天提醒</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div>
          <SelectProduct
            ref="Prod"
            :IsShow="CouponsState == 1 ? false : true"
            :WhetherSee="CouponsState == 1 ? false : true"
          ></SelectProduct>
        </div>
      </el-card>
      <!-- 选择门店弹窗 -->
      <div class="outlet">
        <el-dialog
          width="30%"
          :visible.sync="outletVisible"
          title="礼品券库管理-创建-选择门店"
        >
          <el-form
            size="mini"
            label-width="90px"
            :label-position="labelPosition"
          >
            <el-row
              :gutter="50"
              v-for="(item, index) in StoreSelectionList"
              :key="index"
            >
              <el-col
                :span="12"
                v-for="(myitem, myindex) in item"
                :key="myindex"
              >
                <el-tree
                  ref="tree"
                  v-if="myitem != undefined"
                  :data="[myitem]"
                  show-checkbox
                  node-key="id"
                  highlight-current
                  default-expand-all
                  :props="defaultProps"
                >
                </el-tree>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="ComButtomStore">确 定</el-button>
            <el-button @click="outletVisible = false">取 消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import SelectProduct from "/src/components/SelectProduct/index.vue";
import {
  couponsGroupDetail,
  couponsGroupUpdate,
  couponsGroupOutappList,
} from "@/api/couponsDepot.js";
import { GetShopQueryRegion } from "@/api/viewMemberModule.js";
import { mapState } from "vuex";
export default {
  components: {
    SelectProduct: SelectProduct,
  },
  data() {
    return {
      screenWidth: "",
      ElementHeight: "0px",
      pickerOptions: {
        shortcuts: [
          {
            text: "一周",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "一个月",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "三个月",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "一年",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "两年",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 365 * 2);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      CouponsState: "", //0 :启用   1：未启用   2：已禁用
      switchData: false,
      SecuritiesExpirationType: [
        {
          id: 1,
          detailText: "永不过期",
        },
        {
          id: 2,
          detailText: "从发卷开始固定日期",
        },
        {
          id: 3,
          detailText: "固定过期时间",
        },
      ],
      CouponreminderMethod: [
        {
          id: 0,
          detailText: "不提醒",
        },
        {
          id: 1,
          detailText: "公众号模板消息",
        },
        {
          id: 2,
          detailText: "短信消息",
        },
        {
          id: 3,
          detailText: "公众号模板消息和短信消息",
        },
      ],
      BasicDataRules: {
        couponsName: [
          { required: true, message: "请输入券库名称", trigger: "blur" },
        ],
        innerCoupName: [
          { required: true, message: "请输入券库后台名称", trigger: "blur" },
        ],
        coupValue: [
          { required: true, message: "请输入礼券金额", trigger: "blur" },
        ],
        systemBusinessSelect: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个业务系统",
            trigger: "change",
          },
        ],
        isAllStore: [
          { required: true, message: "请选择使用门店类型", trigger: "change" },
        ],
        listOfSomeStoreslStr: [
          {
            required: true,
            message: "请点击按钮选择部分门店",
            trigger: "change",
          },
        ],
        usageNotice: [
          { required: false, message: "请输入使用需知", trigger: "blur" },
        ],
        maxDiscount: [
          { required: true, message: "请输入最高折扣", trigger: "blur" },
        ],
        useMaxQty: [
          { required: true, message: "请输入最高使用张数", trigger: "blur" },
        ],
        amountLimit: [
          {
            required: true,
            message: "请输入最低使用金额限制",
            trigger: "blur",
          },
        ],
        SecuritiesExpirationTypeSelect: [
          { required: true, message: "请选择劵有效期类别", trigger: "change" },
        ],
        validDaySdata: [
          { required: true, message: "请输入过期天数", trigger: "blur" },
        ],
        datePicker: [
          {
            required: true,
            message: "请选择有效期范围",
            trigger: "blur",
          },
        ],
        expirationTime: [
          {
            required: true,
            message: "请输入劵到期提前多少天提醒",
            trigger: "blur",
          },
        ],
      },
      BasicData: {
        //基本信息
        couponsName: "", //券库名称
        innerCoupName: "", //券库后台名称
        coupValue: "", //礼券金额
        systemBusiness: [], //使用的业务系统
        systemBusinessSelect: [], //选中业务系统
        isAllStore: "全部门店", //是否全门店可用
        listOfSomeStoresl: [], //选部分门店是选择的部分门店
        listOfSomeStoreslStr: "", //选部分门店是选择的部分门店组装数据
        usageNotice: "", //使用需知
        isLimitGoodsDiscount: false, //是否对商品的折扣进行限制
        maxDiscount: "", //最高折扣
        ifGiving: false, //礼品是否可以转送
        useMaxQty: "", //最多使用张数
        amountLimit: "", //使用最低金额限制
        SecuritiesExpirationTypeSelect: 1, //选择的劵有效期方式
        validDaySdata: "  ",
        datePicker: "  ", //有效期
        pubCoupProvideMode: 0, //券发放提醒方式
        expirationMode: 0, //到期提醒方式
        pubVeriCoupMode: 0, //券核销提醒方式
        expirationTime: 0, //到期提醒时间
      },
      outletVisible: false,
      labelPosition: "right",

      // 选择门店数据
      StoreSelectionList: [],
      defaultProps: {
        children: "chlidren",
        label: "lable",
      },
      StoredataArray: [],
      StoreSelectLength: 0,
    };
  },
  mounted() {
    this.getELmentHeight(); //获取页面高度
  },
  watch: {
    //窗口宽度变化
    screenWidth(val) {
      this.ElementHeight =
        document.querySelector(".cashcreation").offsetWidth + "px";
    },
    type(val) {
      if (this.switchData) {
        if (val == 1) {
          this.BasicData.validDaySdata = "  ";
          this.BasicData.datePicker = "  ";
        }
        if (val == 2) {
          this.BasicData.validDaySdata = "";
          this.BasicData.datePicker = "  ";
        }
        if (val == 3) {
          this.BasicData.validDaySdata = "  ";
          this.BasicData.datePicker = "";
        }
      }
    },
  },
  computed: {
    ...mapState({
      CouponsSelectChang: (state) => state.user.CouponsSelectChang,
    }),
    type() {
      return this.BasicData.SecuritiesExpirationTypeSelect;
    },
    isStoreSelectionMethod() {
      if (this.BasicData.isAllStore == "部分门店") {
        return "listOfSomeStoreslStr";
      } else {
        return "Str";
      }
    },
  },
  async created() {
    this.RGetShopQueryRegion(); //获取区域和门店
    await this.RcouponsGroupOutappList(); //获取业务数据
    await this.RcouponsGroupDetail(); //卷库详情
  },
  methods: {
    changeisLimitGoodsDiscount(e) {
      if (!e) {
        this.BasicData.maxDiscount = "";
      }
    },
    getELmentHeight() {
      this.screenWidth = document.body.clientWidth;
      window.onresize = () => {
        return (() => {
          this.screenWidth = document.body.clientWidth;
        })();
      };
    },
    RcouponsGroupDetail() {
      let data = require("qs").stringify({
        couponsGrpID: this.CouponsSelectChang.couponsGrpID,
      });
      couponsGroupDetail(data).then((res) => {
        if (res.success) {
          let SecuritiesUsablegoods = {
            CommodityCategory: "所有商品",
            GoodsGenre: "",
            GenreType: "",
            GenreTypeRegion1: "",
            GenreTypeRegion2: "",
            GoodsType: "",
            GoodsTypeRegion1: "",
            GoodsTypeRegion2: "",
          };
          if (res.data.isAllProduct) {
            SecuritiesUsablegoods.CommodityCategory = "所有商品";
          } else {
            let NewSelectCategoryData = [], //选中的类别数据
              NewSelectCategoryLabelData = [], //选中的类别标签数据
              NewSelectGoodsData = [], //选中的商品数据
              NewSelectGoodsLableData = []; //选中的商品标签数据
            SecuritiesUsablegoods.CommodityCategory = "部分商品";
            if (res.data.productLimitKind == 1) {
              SecuritiesUsablegoods.GoodsGenre = "按类别";
              if (res.data.productMode == 1) {
                SecuritiesUsablegoods.GenreType = "按类别筛选";
                if (res.atrrValueList.length > 0) {
                  let SelectCategoryData = [];
                  res.atrrValueList.forEach((item) => {
                    item.categoryCn = item.AtrrName;
                    item.categoryID = item.AtrrValue;
                    SelectCategoryData.push(item);
                  });
                  NewSelectCategoryData = SelectCategoryData;
                }
                if (res.data.limitContainBD == 1) {
                  SecuritiesUsablegoods.GenreTypeRegion1 = "包含";
                } else {
                  SecuritiesUsablegoods.GenreTypeRegion1 = "排除";
                }
              } else if (res.data.productMode == 2) {
                SecuritiesUsablegoods.GenreType = "按类别标签筛选";
                if (res.lblList.length > 0) {
                  let SelectCategoryLabelData = [];
                  res.lblList.forEach((item) => {
                    item.lblName = item.LblName;
                    item.lblID = item.LblID;
                    SelectCategoryLabelData.push(item);
                  });
                  NewSelectCategoryLabelData = SelectCategoryLabelData;
                }
                if (res.data.limitContainBD == 1) {
                  SecuritiesUsablegoods.GenreTypeRegion2 = "包含";
                } else {
                  SecuritiesUsablegoods.GenreTypeRegion2 = "排除";
                }
              }
            } else if (res.data.productLimitKind == 2) {
              SecuritiesUsablegoods.GoodsGenre = "按商品";
              if (res.data.productMode == 1) {
                SecuritiesUsablegoods.GoodsType = "按商品筛选";
                if (res.atrrValueList.length > 0) {
                  let SelectGoodsData = [];
                  res.atrrValueList.forEach((item) => {
                    item.ProductCode = item.AtrrValue;
                    item.ProductName_CN = item.AtrrName;
                    SelectGoodsData.push(item);
                  });
                  NewSelectGoodsData = SelectGoodsData;
                }
                if (res.data.limitContainBD == 1) {
                  SecuritiesUsablegoods.GoodsTypeRegion1 = "包含";
                } else {
                  SecuritiesUsablegoods.GoodsTypeRegion1 = "排除";
                }
              } else if (res.data.productMode == 2) {
                SecuritiesUsablegoods.GoodsType = "按商品标签筛选";
                if (res.lblList.length > 0) {
                  let SelectGoodsLableData = [];
                  res.lblList.forEach((item) => {
                    item.lblName = item.LblName;
                    item.lblID = item.LblID;
                    SelectGoodsLableData.push(item);
                  });
                  NewSelectGoodsLableData = SelectGoodsLableData;
                }
                if (res.data.limitContainBD == 1) {
                  SecuritiesUsablegoods.GoodsTypeRegion2 = "包含";
                } else {
                  SecuritiesUsablegoods.GoodsTypeRegion2 = "排除";
                }
              }
            }
            this.$refs.Prod.SetdataPage(
              SecuritiesUsablegoods,
              NewSelectCategoryData,
              NewSelectCategoryLabelData,
              NewSelectGoodsData,
              NewSelectGoodsLableData
            );
          }
          if (res.data.isAllStore) {
            this.BasicData.isAllStore = "全部门店";
          } else {
            this.BasicData.isAllStore = "部分门店";
            if (res.shopList.length > 0) {
              res.shopList.forEach((item) => {
                item.id = item.ShopID;
              });
              this.BasicData.listOfSomeStoresl = res.shopList;
              this.BasicData.listOfSomeStoresl.forEach((item) => {
                this.BasicData.listOfSomeStoreslStr += `${item.ShopName}\n`;
              });
              // this.BasicData.listOfSomeStoreslStr =
              //   this.BasicData.listOfSomeStoreslStr.substring(
              //     0,
              //     this.BasicData.listOfSomeStoreslStr.length - 2
              //   );
            }
          }
          if (
            res.outApplications.length > 0 &&
            this.BasicData.systemBusiness.length > 0
          ) {
            let systemBusiness = this.BasicData.systemBusiness;
            res.outApplications.forEach((item) => {
              if (item.optionSelect == "true") {
                systemBusiness.forEach((myitem) => {
                  if (item.outApplicateionID == myitem.outApplicateionID) {
                    myitem.IsCheck = true;
                    this.BasicData.systemBusinessSelect.push(myitem.appName);
                  }
                });
              }
            });
            this.BasicData.systemBusiness = systemBusiness;
          }
          this.BasicData.coupValue = res.data.coupValue; //礼券金额
          this.BasicData.couponsName = res.data.couponsName; //礼券名称
          this.BasicData.innerCoupName = res.data.innerCoupName; //礼券后台名称
          this.BasicData.usageNotice = res.data.usageNotice; //使用需知
          this.BasicData.isLimitGoodsDiscount = res.data.isLimitGoodsDiscount; //是否对商品的折扣进行限制
          this.BasicData.ifGiving = res.data.ifGiving; //礼品是否可以转送
          this.BasicData.maxDiscount = res.data.maxDiscount; //最高折扣
          this.BasicData.useMaxQty = res.data.useMaxQty; //最多使用张数
          this.BasicData.amountLimit = res.data.amountLimit; //使用最低金额限制
          this.BasicData.validDaySdata = res.data.validDay; //券有效日期
          let datePicker = [];
          datePicker[0] = this.renderTime(res.data.startDate); //开始日期
          datePicker[1] = this.renderTime(res.data.endDate); //结束日期
          this.BasicData.datePicker = datePicker.length > 0 ? datePicker : "";
          this.BasicData.expirationTime = res.data.expirationTime; //到期提醒时间
          this.BasicData.SecuritiesExpirationTypeSelect =
            res.data.timeLimitKind; //选择的劵有效期方式
          this.BasicData.pubCoupProvideMode = res.data.pubCoupProvideMode; //券发放提醒方式
          this.BasicData.expirationMode = res.data.expirationMode; //到期提醒方式
          this.BasicData.pubVeriCoupMode = res.data.pubVeriCoupMode; //券核销提醒方式
          this.CouponsState = res.data.state;
          if (
            this.BasicData.validDaySdata == null ||
            this.BasicData.validDaySdata.toString().length <= 0
          ) {
            this.BasicData.validDaySdata = "   ";
          }
          if (
            res.data.startDate == null ||
            res.data.startDate.toString().length <= 0
          ) {
            this.BasicData.datePicker = "   ";
          }
          setTimeout(() => {
            this.switchData = true;
          }, 1000);
        } else {
          this.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    renderTime(date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },

    Butpreservation() {
      this.$confirm("是否确认修改数据", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "修改",
        cancelButtonText: "放弃",
      })
        .then(() => {
          this.requestDey();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "放弃修改",
          });
        });
    },
    requestDey() {
      // 组装数据
      let isAllStore = this.BasicData.isAllStore == "全部门店" ? true : false; //是否选择全部门店
      let endDate = "",
        startDate = "",
        outApplicateionIDS = [],
        shopIDS = [],
        isAllProduct = 0,
        productLimitKind = 1,
        productMode = 0,
        limitContainBD = 0,
        atrrValues = [],
        lblIDs = [];
      if (this.BasicData.SecuritiesExpirationTypeSelect == 2) {
        //劵有效期
      } else if (this.BasicData.SecuritiesExpirationTypeSelect == 3) {
        //劵有效期
        if (this.BasicData.datePicker.length > 0) {
          startDate = this.renderTime(this.BasicData.datePicker[0]).substring(
            0,
            10
          );
          endDate = this.renderTime(this.BasicData.datePicker[1]).substring(
            0,
            10
          );
        }
      }
      if (this.BasicData.expirationTime <= 0) {
        //到期提醒时间
        this.BasicData.expirationTime = 0;
      }
      if (this.BasicData.systemBusinessSelect.length > 0) {
        //      业务系统
        this.BasicData.systemBusinessSelect.forEach((item) => {
          this.BasicData.systemBusiness.forEach((myitem) => {
            if (item == myitem.appName) {
              outApplicateionIDS.push(myitem.outApplicateionID);
            }
          });
        });
      }
      if (!isAllStore && this.BasicData.listOfSomeStoresl.length > 0) {
        //处理选择其他门店
        this.BasicData.listOfSomeStoresl.forEach((item) => {
          shopIDS.push(item.id);
        });
      }
      let SecuritiesUsablegoods = this.$refs.Prod.SecuritiesUsablegoods,
        searchCategoryFormhy = this.$refs.Prod.searchCategoryFormhy,
        searchCategoryLabelFormhy = this.$refs.Prod.searchCategoryLabelFormhy,
        GoodsFormhy = this.$refs.Prod.GoodsFormhy,
        GoodsLableFormhy = this.$refs.Prod.GoodsLableFormhy;
      if (SecuritiesUsablegoods.CommodityCategory == "所有商品") {
        isAllProduct = 1;
      } else {
        isAllProduct = 0;
      }

      if (SecuritiesUsablegoods.GoodsGenre == "按商品") {
        productLimitKind = 2;
      } else if (SecuritiesUsablegoods.GoodsGenre == "按类别") {
        productLimitKind = 1;
      } else {
        productLimitKind = 0;
      }

      if (
        SecuritiesUsablegoods.GenreType == "按类别筛选" ||
        SecuritiesUsablegoods.GoodsType == "按商品筛选"
      ) {
        productMode = 1;
        if (SecuritiesUsablegoods.GenreType == "按类别筛选") {
          searchCategoryFormhy.SelectCategoryData.forEach((item) => {
            atrrValues.push(item.categoryID);
          });
        } else if (SecuritiesUsablegoods.GoodsType == "按商品筛选") {
          GoodsFormhy.SelectGoodsData.forEach((item) => {
            atrrValues.push(item.ProductCode);
          });
        }
      } else if (
        SecuritiesUsablegoods.GenreType == "按类别标签筛选" ||
        SecuritiesUsablegoods.GoodsType == "按商品标签筛选"
      ) {
        productMode = 2;
        if (SecuritiesUsablegoods.GenreType == "按类别标签筛选") {
          searchCategoryLabelFormhy.SelectCategoryLabelData.forEach((item) => {
            lblIDs.push(item.lblID);
          });
        } else if (SecuritiesUsablegoods.GoodsType == "按商品标签筛选") {
          GoodsLableFormhy.SelectGoodsLableData.forEach((item) => {
            lblIDs.push(item.lblID);
          });
        }
      } else {
        productMode = 0;
      }

      if (
        SecuritiesUsablegoods.GenreTypeRegion1 == "包含" ||
        SecuritiesUsablegoods.GenreTypeRegion2 == "包含" ||
        SecuritiesUsablegoods.GoodsTypeRegion1 == "包含" ||
        SecuritiesUsablegoods.GoodsTypeRegion2 == "包含"
      ) {
        limitContainBD = 1;
      } else if (
        SecuritiesUsablegoods.GenreTypeRegion1 == "排除" ||
        SecuritiesUsablegoods.GenreTypeRegion2 == "排除" ||
        SecuritiesUsablegoods.GoodsTypeRegion1 == "排除" ||
        SecuritiesUsablegoods.GoodsTypeRegion2 == "排除"
      ) {
        limitContainBD = 2;
      } else {
        limitContainBD = 0;
      }
      let data = require("qs").stringify({
        couponsGrpID: this.CouponsSelectChang.couponsGrpID,
        couponsName: this.BasicData.couponsName, //券名称
        innerCoupName: this.BasicData.innerCoupName, //券后台名称
        isAllStore: isAllStore, //是否全门店可用
        isLimitGoodsDiscount: this.BasicData.isLimitGoodsDiscount, //是否商品折扣限制
        usageNotice: this.BasicData.usageNotice, //使用需知
        useMaxQty: this.BasicData.useMaxQty, //最多使用张数
        amountLimit: this.BasicData.amountLimit, //使用最低金额限制
        coupValue: this.BasicData.coupValue, //礼券金额
        couponsKind: "0", //劵类型
        startDate: startDate, //开始时间
        endDate: endDate, //结束日期
        expirationMode: this.BasicData.expirationMode, //到期提醒方式
        pubCoupProvideMode: this.BasicData.pubCoupProvideMode, //券发放提醒方式
        pubVeriCoupMode: this.BasicData.pubVeriCoupMode, //券发放提醒方式
        expirationTime: this.BasicData.expirationTime, //到期提醒时间
        ifGiving: this.BasicData.ifGiving, //礼券不可转赠
        isGFCoup: true, //是否GF礼券
        maxDiscount: this.BasicData.maxDiscount, //最高折扣
        outApplicateionID: outApplicateionIDS.join(","), //业务系统
        shopID: shopIDS.join(","), //选择可用门店数组
        timeLimitKind: this.BasicData.SecuritiesExpirationTypeSelect, //劵有效期
        isAllProduct: isAllProduct, //是否商品受限
        productLimitKind: productLimitKind, //受限类型
        productMode: productMode, //商品识别方式
        limitContainBD: limitContainBD, //受限操作
        atrrValue: atrrValues.join(","), //选择的类别编码或商品编码
        ValidDay: this.BasicData.validDaySdata, //券有效日期
        lblID: lblIDs.join(","), //选择标签数组
      });
      couponsGroupUpdate(data).then((res) => {
        if (res.success) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.backHistory();
        } else {
          this.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    preservation() {
      //提交保存 创建卷库
      this.$refs.BasicInformation.validate((valid) => {
        if (!valid) return true;
        this.Butpreservation();
      });
    },
    ComButtomStore() {
      //获取已选择的门店数据
      this.BasicData.listOfSomeStoresl = [];
      this.BasicData.listOfSomeStoreslStr = "";
      for (let index = 0; index < this.StoreSelectLength; index++) {
        let item = this.$refs.tree[index].getCheckedNodes();
        if (item.length == this.StoredataArray[index].chlidren.length + 1) {
          this.BasicData.listOfSomeStoresl.push(
            ...this.StoredataArray[index].chlidren
          );
        } else {
          this.BasicData.listOfSomeStoresl.push(...item);
        }
      }
      this.BasicData.listOfSomeStoresl.forEach((item) => {
        this.BasicData.listOfSomeStoreslStr += `${item.lable}\n`;
      });
      // this.BasicData.listOfSomeStoreslStr =
      //   this.BasicData.listOfSomeStoreslStr.substring(
      //     0,
      //     this.BasicData.listOfSomeStoreslStr.length - 2
      //   );
      this.outletVisible = false;
    },
    RGetShopQueryRegion() {
      //获取区域和门店
      GetShopQueryRegion().then((res) => {
        let arr1 = [],
          arr2 = [];
        if (res.success) {
          res.data.forEach((item) => {
            if (item.chlidren.length > 0) this.StoredataArray.push(item);
          });
          this.StoredataArray.forEach((item, index) => {
            this.StoreSelectLength += 1;
            if (index % 2 == 0) {
              arr1.push(item);
            } else {
              arr2.push(item);
            }
          });
          this.StoreSelectionList = arr1.map((key, value) => [
            key,
            arr2[value],
          ]);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    RcouponsGroupOutappList() {
      couponsGroupOutappList().then((res) => {
        if (res.success) {
          res.data.forEach((item) => {
            item.IsCheck = false;
          });
          this.BasicData.systemBusiness = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    backHistory() {
      this.$router.go(-1); //返回上一层
    },
  },
};
</script>
<style lang="scss" scoped>
.elUpload {
  box-sizing: border-box;
  border: none;
  display: flex;
  justify-content: center;
  width: 98px;
  height: 34px;
}
.buttom-flex {
  display: flex;
  flex-direction: row;
}
.ConponesName {
  text-decoration: underline;
  color: #a19b59;
}
.ConponesName:hover {
  cursor: pointer;
}
.margig-left80 {
  margin-left: 80px !important;
}
.formClass {
  margin-top: 10px;
}
.SelectArea {
  display: flex;
  margin-top: 8px;
  width: 140px;
}
.CategoryFiltering-div-top {
  display: flex;
  align-content: center;
  justify-content: space-between;
}
.CategoryFiltering-div {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  width: 500px;
  height: 100%;
}
.CategoryFiltering-conter {
  // border: 1px solid #a8a8a8;
  display: flex;
  width: 1120px;
  height: 100%;
  margin-top: -15px;
}
.CategoryFiltering {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 700px;
  margin-top: 20px;
}
.right-top {
  display: flex;
  flex-direction: column;
  height: 430px;
}
.right-buttom {
  display: flex;
  flex-direction: column;
  height: 430px;
  margin-top: 20px;
}
.part-class-right {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.part-class-left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 80px;
  height: 470px;
}
.Coupons-part {
  display: flex;
  flex-direction: row;
  height: 100%;
  margin-left: 50px;
}
.Conpone-flex {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 10px;
  height: 50px;
}
.MaturityOfSecurities {
  display: flex;
}
.periodOfValidity {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.form-div {
  padding: 20px 0px;
  padding-left: 100px;
}
.textareaClass {
  resize: none;
  width: 100%;
}
.textareaClass-store {
  padding: 2px 10px;
}
.cashcreation {
  margin-bottom: 100px;
}
.push-button {
  width: 100px;
  background-color: #e9e7d3;
}
.buttom-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 250px;
  align-content: center;
}
.header-title {
  min-width: 250px;
  line-height: 50px;
  height: 50px;
}
.header-text1 {
  height: 3.5rem;
}
.header-text {
  position: fixed;
  z-index: 88;
  margin-top: -1.25rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  background-color: #f3f5f7;
  height: 4.5rem;
  color: #76734f;
  padding-bottom: 5px;
}
.biaoti {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  padding-left: 50px;
  background-color: #e3e3e3;
}
::v-deep {
  .el-card__body {
    padding: 20px 0 20px 0;
  }
  // 选择门店弹框样式
  .outlet {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 20px 10px 20px 10px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2;
    }
  }
}
</style>